import { Injectable } from '@angular/core';
import { ToastController, ToastButton as IonicToastButton, ToastButton } from '@ionic/angular';
import { ToastConfig } from '../models/notification/toast-config-interface';
import { TOAST_DURATION, TOAST_POSITION, TOAST_CLASS } from '../enums/notification/notification.enum';


@Injectable()
export class ToastNotificationService {
  constructor(private toastController: ToastController) {}

  async show(config: ToastConfig) {
    const existingToast = await this.toastController.getTop();

    if (existingToast) {
      existingToast.dismiss();
    }

    if (!config.duration) {
      config.duration = TOAST_DURATION.SHORT;
    }

    if (!config.position) {
      config.position = TOAST_POSITION.BOTTOM;
    }

    if (!config.cssClass) {
      config.cssClass = TOAST_CLASS.SUCCESS;
    }

    const toast = await this.toastController.create({ ...config, cssClass: [config.cssClass, 'form-submit-toast'], buttons: this.createToastButton(config.buttons ?? []) });

    await toast.present();

    toast.ontouchend = () => {
      toast.dismiss();
    };
    toast.onclick = () => {
      toast.dismiss();
    };
  }

  private createToastButton(buttons: [ToastButton?, ToastButton?]): IonicToastButton[] {
    const ionicButtons: IonicToastButton[] = [];

    buttons.forEach((btn) => {
      if (!btn.cssClass) {
        btn.cssClass = TOAST_CLASS.SUCCESS;
      }
      ionicButtons.push({ ...btn, side: 'end' });
    });

    return ionicButtons;
  }
}
